import { render } from "./ReportViewSwitch.vue?vue&type=template&id=38e07a12&scoped=true"
import script from "./ReportViewSwitch.vue?vue&type=script&lang=js"
export * from "./ReportViewSwitch.vue?vue&type=script&lang=js"

import "./ReportViewSwitch.vue?vue&type=style&index=0&id=38e07a12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e07a12"]])

export default __exports__